import { render, staticRenderFns } from "./VSelectionField.vue?vue&type=template&id=fe81f25a"
import script from "./VSelectionField.vue?vue&type=script&lang=js"
export * from "./VSelectionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports